// src/pages/SafetyTips.jsx
import React from 'react';

const SafetyTips = () => {
  return (
    <div className="page-container">
      <h1 className="page-title">Safety Tips for Pilgrims</h1>
      <p>Essential advice to ensure a safe and secure pilgrimage experience.</p>
    </div>
  );
};
export default SafetyTips;